export const PricingToolRoute = {
  path: '/Application/Pricing',
  load: () => import('./PricingTool'),
  hideLayout: true,
};
